module.exports = __webpack_public_path__ + "img/c5.9aa99389.jpg";